module.exports = __webpack_public_path__ + "9b2ab16dc71f6d23e7ad5cf798628e68.woff2";